/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { projectGroupsControllerGetProjectGroups } from "./projectGroupsControllerGetProjectGroups";

export function projectGroupsService() {
  return { projectGroupsControllerGetProjectGroups }
}